import script from "./domtrrchild.vue?vue&type=script&setup=true&lang=js"
export * from "./domtrrchild.vue?vue&type=script&setup=true&lang=js"

import "./domtrrchild.vue?vue&type=style&index=0&id=774e94ad&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774e94ad"]])

export default __exports__